import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect'
import { routerActions } from 'react-router-redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import { selectAccount } from '../ducks';
import { debtorRegistrationActions } from '../../../common/enums';

// redirect user to the documents tab if they need to upload documents
export default connectedRouterRedirect({
  authenticatedSelector: state => {
    let account = selectAccount(state); 
    
    if (account) {
      let registrationAction = account.registrationAction;

      if (registrationAction) {
        return registrationAction !== debtorRegistrationActions.UPLOAD_DOCUMENTS && registrationAction !== debtorRegistrationActions.UPLOAD_BANK_ACCOUNT_STATEMENTS;
      }
    }

    return true;
  },
  authenticatingSelector: state => selectIsInProgress(state, apiCallIds.LOGIN),
  redirectPath: state => (selectAccount(state) ? '/dashboard/documents' : '/auth/login'),
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'IsVerified',
});



// WEBPACK FOOTER //
// ./src/features/auth/utils/IsVerified.js